import IMask from 'imask';

(function initMask() {
    const inputs = document.querySelectorAll('[data-mask]');


    inputs.forEach(input => {
        const maskOptions = {
            mask: input.dataset.mask,
            lazy: false,
        };

        IMask(input, maskOptions);
    })
})();
